import { AxiosError, AxiosResponse } from 'axios';

import { transformIncomingData } from './dataTransform';
import { normalizeApiErrors } from './normalizeApiErrors';

interface SuccessResponse<T = unknown> {
  data: T;
  type: 'success';
  headers?: AxiosResponse<T>['headers'];
}

interface IncomingError {
  errors: string[];
  conflictType?: string[];
}

interface ErrorResponse<K = unknown> {
  error: IncomingError;
  type: 'error';
  data?: K;
  status?: number;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiResponse<T = any, K = any> = SuccessResponse<T> | ErrorResponse<K>;

export const transformSuccess = <T>({ data, ...rest }: AxiosResponse<T>): ApiResponse<T> => {
  return { ...rest, type: 'success', data: data };
};

export const transformError = <T, K = { errors: [] }>({ response, message }: AxiosError): ApiResponse<T, K> => {
  if (message === 'canceled') {
    return { ...response, type: 'error', error: { errors: ['Canceled request'] }, data: undefined };
  }
  if (response?.status === 401) {
  } else if (response?.status === 500) {
    return {
      ...response,
      type: 'error',
      error: { errors: ['Internal Server Error! Please try again later'] },
      data: undefined,
    };
  }

  const incomingData = transformIncomingData(response?.data) as (IncomingError & K) | undefined;
  const error: IncomingError = { ...incomingData, errors: normalizeApiErrors(incomingData?.errors) };

  return {
    ...response,
    type: 'error',
    error,
    data: incomingData as K,
  };
};
